import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { propertyAttributeServices } from '../services/propertyAttribute.service';

export const useUpdatePropertyAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => propertyAttributeServices.updatePropertyAttribute({ id, data }),
    onSuccess: () => {
      queryClient.invalidateQueries(['property-attributes']);
      toast.success('Attribute updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update attribute');
    },
  });
};
